import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "report-section signatures" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "15%" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Who")
    ]),
    /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { width: "19%" }, "Signed"),
    /*#__PURE__*/_createElementVNode("th", { width: "6%" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createTextVNode("A "),
  /*#__PURE__*/_createElementVNode("strong", null, "Forwarding Address"),
  /*#__PURE__*/_createTextVNode(" can be added on the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Details"),
  /*#__PURE__*/_createTextVNode(" tab.")
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import SignatureRow from '@/components/report/SignatureRow.vue';
import { Report, Signature } from '@/models';
import { ReportsState } from '@/store/reports/types';

// Props and state

export default /*#__PURE__*/_defineComponent({
  __name: 'Signatures',
  setup(__props) {

const store = useStore();
const reportsState = computed(() => store.state.reports as ReportsState);

// Computed properties
const report = computed(() => reportsState.value.current);
const signatures = computed(() => reportsState.value.current.signatures);

// Methods
const addSignature = async (): Promise<void> => {
  await store.dispatch('reports/addSignature');
};

// Injects (if applicable)
const actProperty: any = inject('actProperty');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(signatures.value, (signature) => {
          return (_openBlock(), _createBlock(SignatureRow, {
            key: signature._uuid,
            signature: signature
          }, null, 8, ["signature"]))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addSignature()))
    }, [
      _hoisted_4,
      _createTextVNode(" Signature ")
    ]),
    (report.value.type === 'checkout')
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true)
  ]))
}
}

})